import {
    agreeTerms,
    agreeTracking,
    fetchUserAbout,
    setPreferredCountry,
} from '../api/user.api';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { isSpateUser } from '../helpers';
import useOptimisticMutation from './useOptimisticMutation';
import { useSelector } from 'react-redux';

const queryKey = 'user-about';

export const useSetPreferredCountry = () => {
    const qc = useQueryClient();
    return useMutation(setPreferredCountry, {
        onSuccess: () => qc.invalidateQueries(queryKey),
    });
};

export const useFetchUserAbout = (config = {}) =>
    useQuery(queryKey, () => fetchUserAbout(), {
        staleTime: Infinity,
        cacheTime: Infinity,
        ...config,
    });

// Declines when nothing is cached: fabricating a record here hands every reader
// a user-about shape the server can never return.
const getUpdateFn = (name) => (userAbout) =>
    userAbout && {
        ...userAbout,
        agreements: [
            ...(userAbout.agreements ?? []),
            { name, agreed_time: Date.now(), agreed: true },
        ],
    };

export const useAgreeTerms = () =>
    useOptimisticMutation(queryKey, agreeTerms, getUpdateFn('terms'));
export const useAgreeTracking = () =>
    useOptimisticMutation(queryKey, agreeTracking, getUpdateFn('tracking'));

export const useHasPermission = (permission) => {
    const { data, isLoading } = useFetchUserAbout();
    if (isLoading || !data) {
        return { hasPermission: false, isReady: false };
    }
    return {
        hasPermission: Boolean(data.permissions?.includes(permission)),
        isReady: true,
    };
};

export const useIsAdmin = () => {
    const session = useSelector(({ session }) => session);
    return (
        session &&
        isSpateUser({
            company: session.company,
            email: session.user_email,
        })
    );
};
